import { OnDestroy, OnInit, Component } from '@angular/core';
import { ValidatorService } from 'app/shared/services/validator.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { IEmploymentHistoryItem } from 'app/shared/models/recruitment/employment-history-item.model';
import { RecruitmentService } from 'app/views/appviews/recruitment/recruitment.service';

@Component({
  selector: 'app-modal-employment-history-comments',
  templateUrl: 'modal-employment-history-comments.template.html'
})
export class ModalEmploymentHistoryCommentsComponent implements OnDestroy, OnInit {
  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [false];
  private flag = false;
  private errorMessages: any;
  /**Formularios */
  private formComments: FormGroup;
  /**Retorno a pantalla padre */
  public onClose: Subject<IEmploymentHistoryItem>;
  private historyItem: IEmploymentHistoryItem;
  constructor(private formBuilder: FormBuilder
    , private bsModalRef: BsModalRef
    , private recruitmentService: RecruitmentService) {
    this.initializeFormComments();
  }
  ngOnDestroy(): void {
  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.patchValueComments();
  }
  private patchValueComments(): void {
    this.formComments.patchValue(this.historyItem);
  }
  private initializeFormComments() {
    this.formComments = this.formBuilder.group({
      commentHistory: [null, Validators.required]
    });
  }
  private submitForm(): void {
    if (this.formComments.valid) {
      this.update();
    }
  }
  private update(): void {
    this.historyItem.commentHistory = this.formComments.value.commentHistory;
    this.recruitmentService.updateEmploymentHistoryItem(this.historyItem)
      .subscribe(
        (x) => {
          if (x.isCorrect) {
            this.onClose.next(this.historyItem);
          }
          this.bsModalRef.hide();
        },
        (errMessage) => this.errorMessages = errMessage.messages);
  }
  private onCancel(): void {
    this.bsModalRef.hide();
  }
}